var map = {
	"./de.json": [
		34944,
		4
	],
	"./en.json": [
		11919,
		813
	],
	"./es.json": [
		15480,
		974
	],
	"./fr.json": [
		94055,
		367
	],
	"./it.json": [
		9538,
		992
	],
	"./nl.json": [
		60277,
		153
	],
	"./pt.json": [
		96679,
		962
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98989;
module.exports = webpackAsyncContext;